import { render, staticRenderFns } from "./secondhandDetailsApply.vue?vue&type=template&id=036f8646&scoped=true&"
import script from "./secondhandDetailsApply.vue?vue&type=script&lang=js&"
export * from "./secondhandDetailsApply.vue?vue&type=script&lang=js&"
import style0 from "./secondhandDetailsApply.vue?vue&type=style&index=0&id=036f8646&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036f8646",
  null
  
)

export default component.exports